import { jsx } from 'react/jsx-runtime';
import * as React from 'react';
import { c as classNames, b as EGDSContextWrapper } from '../index_orig/index-chunk.esm.js';
import { b as EGDSButton } from '../button/index-chunk.esm.js';
import '../icon/index-chunk.esm.js';
class EGDSTertiaryButton extends React.Component {
  static displayName = 'EGDSTertiaryButton';
  render() {
    const {
      className,
      alignLabelToContent,
      inverse,
      ...props
    } = this.props;
    const cssClassNames = classNames(`${EGDSButton.baseClassName}-tertiary`, className, {
      [`${EGDSButton.baseClassName}-tertiary-align-with-content-${alignLabelToContent}`]: alignLabelToContent,
      [`${EGDSButton.baseClassName}-tertiary-inverse`]: inverse
    });
    return jsx(EGDSContextWrapper, {
      children: context => jsx(EGDSButton, {
        ...props,
        className: cssClassNames,
        "data-context": context
      })
    });
  }
}
export { EGDSTertiaryButton as E };